import React, { useEffect } from 'react';
import { useParams } from 'react-router';

import { useAppDispatch, useAppSelector } from 'store/hook';
import { handleSetSelectedParentCommunity } from 'store/slices/globalSlice';
import { getCommunityById } from 'utils/helpers/communityMap';

import CommunityInfoCompetitorOverview from '../CommunityInfo/CommunityInfoCompetitorOverview';

const Competitor = () => {
  const { competitorId } = useParams();
  const dispatch = useAppDispatch();

  const { selectedCommunity, communityMap } = useAppSelector((state) => state.global);

  useEffect(() => {
    if (selectedCommunity) {
      const parentCommunity = getCommunityById(communityMap, selectedCommunity.id);

      if (!parentCommunity) {
        return;
      }

      dispatch(handleSetSelectedParentCommunity(parentCommunity));
    }
  }, [selectedCommunity, communityMap, dispatch]);

  return <CommunityInfoCompetitorOverview />;
};

export default Competitor;
